import { createApiRef } from '@backstage/core-plugin-api';

export interface PullRequestRef {
  number: number;
  title: string;
  author: string;
  mergedAt: string | null;
}

export interface ChangeRow {
  releaseId: string;
  openedAt: string | null;
  mergedAt: string | null;
  builtAt: string | null;
  prNumbers: PullRequestRef[];
  ciaSha: string | null;
  dekiSha: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ListChangesOptions {
  limit?: number;
}

export interface ChangesApi {
  listChanges(opts?: ListChangesOptions): Promise<ChangeRow[]>;
  getChange(releaseId: string): Promise<ChangeRow>;
}

export const changesApiRef = createApiRef<ChangesApi>({
  id: 'plugin.changes.service',
});
